import React from "react"
import "./ConsultantDirectory.scss"

export const COLUMNS = [
  {
    Header: "",
    accessor: "colorCoding",
    Cell: (row: any) => {
      return (
        <div
          className="color-cod-consultant"
          style={{
            width: "80px",
            height: "80px",
            backgroundColor: row.value,
            borderRadius: "10px 0 0 10px",
            marginLeft: "-10px",
          }}
        >
          {row?.value === 'consultantProfilePic' &&

            <img
              src={row?.value}
              width={100}
              height="fit-content"
              style={{
                width: "29px",
                height: "32px",
                marginTop: "27px",
                marginLeft: "10px",
                fill: "white !important",
              }}
              alt=" "
            />
          }
        </div>
      )
    },
  },
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Role",
    accessor: "primaryRole",
    Cell: (row: any) => {
      return <span title={row?.value}>{row.value?.charAt(0)?.toUpperCase() + row.value?.slice(1)?.toLowerCase()}</span>
    },
  },
  {
    Header: "Services Offered",
    accessor: "servicesOffered",
    height: "100px",
    Cell: (row: any) => {
      return <span title={row.value}>{row.value}</span>
    },
  },
  {
    Header: "Time available",
    accessor: "availabilityTimeFrame",
    Cell: (row: any) => {
      return <span className="availabletime">{row.value?.length > 0 ? row.value?.join("\n ") : null}</span>
    },
  },
  {
    Header: "Phone Number",
    accessor: "phoneNumber",
    disableSortBy: true
  },
  {
    Header: "Email",
    accessor: "email",
    Cell: (row: any) => {
      return <span title={row.value}>{row.value}</span>
    },
  },
]
